import './CommentSection.scss';
import { CommentList } from './CommentList';
import { CommentOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { CreateCommentNotification } from './CreateCommentNotification';
import { DeleteCommentNotification } from './DeleteCommentNotification';
import { InitiativeSection } from '../general';
import { OffsetPaginator } from '@ui/OffsetPaginator';
import { UpdateCommentNotification } from './UpdateCommentNotification';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const commentsSelectors = createAsyncSelectors((state) => state.core.initiatives.comments.get);
export const CommentSection = ({ initiativeId }) => {
    var _a;
    const totalCount = (_a = useSonarSelector(commentsSelectors.data)) === null || _a === void 0 ? void 0 : _a.totalCount;
    const get = useAction(coreActions.requestGetCoreInitiativesComments);
    const handleGet = useCallback((args) => get(Object.assign(Object.assign({}, args), { initiativeId })), [get, initiativeId]);
    const renderComments = useCallback((data) => React.createElement(CommentList, { data: data, initiativeId: initiativeId }), [initiativeId]);
    return (React.createElement(InitiativeSection, { count: totalCount, icon: React.createElement(CommentOutlined, null), id: 'initiative-comments-section', title: COPY_SPECIFIC.COMMENTS },
        React.createElement(OffsetPaginator, { render: renderComments, request: handleGet, selector: commentsSelectors.data }),
        React.createElement(CreateCommentNotification, null),
        React.createElement(DeleteCommentNotification, null),
        React.createElement(UpdateCommentNotification, null)));
};
